import { createMachine } from 'xstate'
export const TicketMachine =
/** @xstate-layout N4IgpgJg5mDOIC5QBUCWBjA1mALgYgAcBXWACwXQHsA7AM1SgG0AGAXUVAMtlR1Ro4gAHogBMATgDMogHQB2AGwBWAIyKFo0QA5xKgDQgAnmOZzJMhSoAsWycy1KlG0QF8XBtFlwzkASQDCANIAosgA+gCyAIL+ABK+AHLBMr7UvJ7Y+GAATtmU2TIEADYAhji0+QC2PhiZPgEh4dFxicmp6bW4CKjUAG6U6GX81Cyso4JcPHwCSMKI4gpyMpIqolaKWswKWnIGxggq9uLLClY2uotWym4enTj1QaGRMfFJKWk4Gbh4NBSkYF4IAg+F4cONZpNeMNBCIEAslis1hstjs9ogVJJVDIMZslMxJJZmOI5K53CAvvc-I8mi9Wu8OqC8EJYDgymAZCVaDgcgAKFR45jMACUeApD0azxab3anzu4M43ChM1AsPhy1W622KN2RnRqi02Oslm0uhUCgWN3Jd3FT2ar2SAAUogBxYJhYIAJQ9AHkPXgAEYlLDISi+CBFMDykCQ6bUGGIJRyYkyUxyKziK7icRE0Rog7rWQqYniLRWVaYrSly1iqkSu10p2u91e31Mllsjlc3l8Spgb1EHD+ErUdBgIoimsNW20t6Nt2en0eqMx6GzWGJ5Op9OZ7PiXO6g5KTQWEtbZjp0ySdPV6216dSx0ut0AdR9CWdYTiwSCYUSAaDmAhmGEbLoqsbxggSibEsW4Zuau77vsZpyAaRZJlmChbFYjhWDeoI2jSD4yHOYSvt676frE36BL+CRtqy3Kdty2Q8j2fYDkOI5jhOt5ToR9rEU+pFvh+X4-okoFTKuKoJkmMFyGmcFZjmeZqNoJ7QUoxIEswpK3Phd78XSYkhAAImEhm0WEDregAMr4eCSUqcZruiVwqCmGiSAp6w6JIe55mW5jMFppxSAS-JWHpVoGXxkoCSZwTmZZiTWXZDmMCo7AQmB0lzPmlieaI3lpihUgBQeZoaBYRoSPiJVKHhdSWfWbyJclcWpTZ9mOaI2UKlJyr5UaHlbMVPllf5iHot5CiGlcWiiAokiYqIRZNd4LUzskJkWXFsRRAAam6HrBBEiSmY5bATLlQ2wqIpijc4hwoXIKhaNYeb+cwywrUWawliSOwbZScWtTtVE-pZB3HWEp3nQkl2Zf10a3S5MkIA9b1FWtpg7O9n0HpoP0CrpH0rSFCggwR8XGZDNHQ0dJ1nRdvUoyud0mNjY2469BNWHmWgKHNQsLboQXSCo1NbURu0pQkFnxAAyp+tkAKpK8gnpXezaMQSscg-YoqhnCSxKrHm5oeZqZaZkoUWSNLYPbTIcudQryDK6rGta36yM3YN6P5QbRvKNYBbm9NCBC3N+IYo40FZpWTvUrTs5CUriTOrZbomX+1BgEIOBK9yBBOeBrkIN5BIyFmUhqMSZiogei0-cSy06AsVi6USKd1i7JGZ++OeUdRf6BsGobhpG105YHEEbvJik7ipB52FY2KiHiHf+U4vdkpOqfg4JTZD9nuf03+zIMeynLMaxqC9v2OC2T0YAlNkPGxUfA8Z1nI95wSOXPK645Iph8kpBCltszyCWpiDQah976Was7IiJEIhq1sn4B0ADL50QLkXEuYAy6zwGs5fWKEDQfWKqWMs+JHA6iQoKDeBIyz2zDobZgUsD68R-mgoSGCsG+BwRfMedFYBjgBDgBADoSg8DACMUhqN56V2kKcGQVx-KWH5BoKwkhVL4iWGoBwlYSy6C3nIPu94BLoMwdg3BYj-yT2AjPXWKiMaL3AcveCq99hNxkJoU441DjiFUJYnh39+78KbII+xoighX3bIxO+3ZH7sRfm-D+X8UF8JsQIuxwiHEJKAUojmQd1zQS8duHxFUkLLR+uaJMktVhaW8lYoy6cmyWXhqzAhxdS7AM5pjMwc1ETvR2FBW2eY0zmFFuTew2gVjtLTo+LpcUemIycYBKeIFSl60rp42CK9akmDmhqXQWYUKOFEGYZZx8SLdJZps6+HYUksTYs-V+Bcsmil4VEvJazU4bNMoM8pCZKlHJqVHLec1dEYSvE4LM0VD7-IbN6TWe1qR4ByHkAoxQygVGyNUFF1i0UYsMt0PoAwhg0FGKCiCZYhbyBWqobytgjwC0qg9A0lhsKaHFlou5A90XhEMj8agfwASYB6MCOUez3H5UZXNMwmIMQoVWpy-Y9sEREhJGmdMeJgYRJyai2cIrMWNHoq8rsLF+SCmFL8yJpKzXkr4vSyuSrmWqrZRq1SML5paXPAsxMWghVEUsrtP87qMZXEWAE4xJJlA6Cgl9GBdchY6Qet5K4YaBIRvprRRyWUA7kI9cLJYa1XpLSgqErQeZ7YGkTdhQ2Kw7XiFzQ2DOat-D+GCErFWZ8ik0XHgBIC09o35UORA45Uds0aLrjclYndVAds6W6JW3be39rCIO+Jw66IvOSTah+T8OLDlHOOR1JrnWrPXZuvtA7-57tohO0Bm5p1QsClvFM9r8TbF5fyRqxrNqoIBXentD7IgFJEaPcSdEJ7bJca+2S77vHKROZBaQASlrd0Wtoew6xV23p3fe7dsTCnPsSTfJiqTT2DnPdxK9IHcmdtPqRlW5GYORpKW40tHiwGQvQ1HKCsgm2li0keVtRGZCunCFEBIyAPS+Hk2Eeyms8BkEoAAdwQMOHA2RUDDmQ5BJEKYpAhTkE4XE4gvrCxTMVbCy1zTCxCkB5BzHTXJCVsEHO-g-DkTCKZKIyAog6xLRXDGId5Bh1NhIN6UcFiyCUK2xMix+VXmplEUyCNrJPhkFlhGVqj331Jtk7wBWup5Yqzx8LID5j+RkOwnQ6w1BBUYeiUs5hWG2DUTo2w1NfCmRHnODTgwJUgkyAgaV3BMDGe7iTKQKEzh4y0qpSZ2JLDJeS9hfEQsBtDbdCN2AY3ZWgim-wWAs3i1zz44qwUjXFu0JWzZyqmxZCSErIcHYHc5L7eG0+Ubw5TuTem5dxgfVatDMczVAGXCVBmgcO1zGIVrZRX+thPcGJcLAfuIN-7roUgJF8MgMLN2Iv5U0AaX9+IlpZoUqpJMshioLGzBoewpwqY45SAd3LBPZOqaiAAIR83gCANB2Q9H6NgGo+E8eHby-z2yQufOUv6IMWMdL5W3dhPD4KuIFmXN0FsVSScAkaEwnuBwuhpN+AiMEb0atwj88SAAMW9KL8XMhJeUGlySjpyRbf28d2EZ3CQ3eq+pRrtgc28RLGwh90WK0PvYTW7YFM8P3oZgWCGoDZJqCUAgHAQQFJIdgrhHmAAtGsH9gooKpmQvDojpeIKG2VdQ04NgrgSH0ZVQ486syzQ1Aw8J7nQYselB8EvZO6sIEsxvFCqwO+lg0FIVSmIfqi04eNUslnpMkQXL6ZvHq9HHAWocblZZFiqU0RomwIUQp2FPI7LnMswPCXIqJAtiQj8YzUNVCQGIS0O+KECgqky0CIHOsaH2hwWw0m7UFqTwXU6UP+w0ZoP0Egiwhsi0ZgXca+eIMgoswsFwlgCecBBajMsMwKKBOuJIG8cc9gi00gCkV+a8MCjg7clYdChw2EZB1ECB4QqUnsvgKs-g6smsno1BYgostc3kIU2EyWNOPe+wiOBBpwigq0qg2ke+f8w8e63+0+QyV43kGidUIUUgyglsdmgSKwjcxIAM2hMS0GQ6+hZC5OsIRhP03ciY7kAom2eYFwFgTgW86YlO-IoaL+oGrGbojyCMpkkhmMbCtcR47eV4tOSgJuSwdce4W8xIos7aER4+jo5qhk8R-kdgFg-ki0OwigeiSOnBASWicORIzRyKfyN6NM3G8RZwTgywOgKqdgWiwm3cjWWkm+NgV4GYDh4GW6j6uhsG+68R9s6wBBei9U2q32tmSg8g6YA+iaH25oUxJGEGZGThlGCQXRug5gSYga3cQMZo6RB4kmGiNRaYy02q1wBRnmMmTw8mimymCsamyAFx2wjW5o6Yy0-KKea8yg2xdc3kcCQs+Ro+NMx83mvm-mCsQWIW8R2gUEGioxlmuMgohM+wpuukf00Euu-kmW2WlWro8RZgo0xIXCexOxUc-0xwXCcCZ4u24RyJ1WvOyQ1WDJSYZmhsaky0bJeYD0ZojWi+gGiOdhf28u9JBhZeiYYB54GiOgS+GgpYXCypgphOxO8RhwDxSESYbcOp2w3cwRpwhpc43x4QSuwutkppS0tcb0uRH0oShwH2qkEyKYpY2gQsH0RIy0DpeWpk5EwQOJWYywjgahOw0gV4SORYmwgRoSV4xJABfJMU16-u9QduDuTuiBYe3oXRyEoJ545oeIUU+Ia2GIJwpwBISYRYoUbgbgQAA */
createMachine({
  entry: 'setCtxConfigure',
  id: 'Ticket',

  states: {
    TICKET_MACHINE: {
      initial: 'InitTicket',
      states: {
        InitTicket: {
          invoke: {
            src: 'getTicketInfo',
            onError: 'PAGE_ERROR'
          },
          after: {
            15000: {
              target: 'TIMEOUT_GET_INFO',
              actions: []
            }
          },
          on: {
            'on:checked:ticket': {
              target: 'CHECKED_TICKET_IN_POLI',
              actions: 'setCtxDetailTicket'
            }
          }
        },

        PAGE_ERROR: {
          entry: 'setCtxErrorPage',

          on: {
            backToIdle: {
              target: '#Ticket'
            }
          },

          after: {
            timeOutCancel: {
              target: '#Ticket',
              actions: [],
              internal: false
            }
          }
        },

        PAGE_WRONG_CHECK_IN: {
          entry: 'setCtxPageWrongCheckIn',

          on: {
            backToIdle: '#Ticket'
          },

          after: {
            timeOutCancel: {
              target: '#Ticket',
              actions: []
            }
          }
        },

        CHECKED_TICKET_IN_POLI: {
          entry: ['setCtxArrReduceThisCluster'],
          always: [
            {
              target: 'CHECK_TICKET_HAVE_REMIND',
              cond: 'isHaveThisCluster',
              description: 'apakah ticket mempunyai cluster'
            },
            {
              target: 'PAGE_WRONG_CHECK_IN',
              cond: 'ticketHaveCluster'
            },
            {
              target: 'PAGE_ERROR'
            }
          ]
        },

        CHECK_TICKET_HAVE_REMIND: {
          entry: [
            'setCtxTicketLateNotThisCluster',
            'setCtxTicketHasCheckInThisCluster'
          ],
          always: [
            {
              target: 'TICKET_CHECK_IN',
              cond: 'isAllTicketAllreadyCheckIn',
              actions: 'setCtxTypeWarning',
              description: 'cek ticket yang hanya mempunyai list check in'
            },
            {
              target: 'PAGE_TICKET_REMIND',
              cond: 'isHaveTicketRemind',
              description: 'cek tiket apakah mempunyai ticket remind'
            },
            {
              target: 'CHECK_TICKET_IN_THIS_CLUSTER'
            }
          ]
        },

        CHECK_TICKET_IN_THIS_CLUSTER: {
          always: [
            {
              target: 'PAGE_SINGLE_CHECKIN',
              cond: 'isHaveTicketOnlyOnePoli'
            },
            {
              target: 'PAGE_MULTIPLE_CHECKIN'
            }
          ],

          entry: 'editCtxArrOnlyArriveCluster'
        },

        PAGE_SINGLE_CHECKIN: {
          entry: 'setCtxPageSingleCheckIn',
          on: {
            nextStep: {
              target: 'POST_TICKET',
              actions: 'setCtxLoadingPage'
            },
            backToIdle: {
              target: '#Ticket'
            }
          },
          after: {
            timeOutLinear: {
              target: '#Ticket',
              actions: [],
              internal: false
            }
          }
        },

        PAGE_MULTIPLE_CHECKIN: {
          entry: 'setCtxPageMultipleCheckIn',

          on: {
            nextStep: {
              target: 'POST_TICKET',
              actions: 'setCtxLoadingPage'
            },

            'select:Pasien': 'SELECTION_DATA',
            backToIdle: '#Ticket'
          },

          after: {
            timeOutLinear: {
              target: '#Ticket',
              actions: []
            }
          }
        },

        PAGE_TICKET_REMIND: {
          entry: 'setCtxPageRemind',
          exit: 'deleteCtxArrTicketNotThisCluster',
          on: {
            nextStep: {
              target: 'CHECK_TICKET_IN_THIS_CLUSTER'
            },
            backToIdle: {
              target: '#Ticket'
            }
          },
          after: {
            timeOutLinear: {
              target: '#Ticket',
              actions: [],
              internal: false
            }
          }
        },

        POST_TICKET: {
          exit: 'setCtxTypeSuccess',
          invoke: {
            src: 'postCheckInTicket',
            onError: [
              {
                target: 'PAGE_ERROR'
              }
            ]
          },
          after: {
            15000: {
              target: 'TIMEOUT_GET_INFO',
              actions: []
            }
          },
          on: {
            'on:checkin:ticket': 'TICKET_CHECK_IN'
          }
        },

        TICKET_CHECK_IN: {
          always: [
            {
              target: 'GET_ANTRIAN_LIST',
              cond: 'isTicketCheckInOnlyOne'
            },
            {
              target: 'PAGE_SUCCESS_MULTIPLE_CHECK_IN'
            }
          ],

          entry: 'editCtxOnlyCheckInThisCluster'
        },

        PAGE_SUCCESS_SINGLE_CHECK_IN: {
          entry: 'setCtxSinglePageCheckIn',

          on: {
            backToIdle: '#Ticket'
          },

          after: {
            timeOutCancel: {
              target: '#Ticket',
              actions: []
            }
          }
        },

        PAGE_SUCCESS_MULTIPLE_CHECK_IN: {
          entry: 'setCtxMultiplePageCheckIn',

          on: {
            backToIdle: '#Ticket'
          },

          after: {
            timeOutCancel: {
              target: '#Ticket',
              actions: []
            }
          }
        },

        GET_ANTRIAN_LIST: {
          invoke: {
            src: 'getInfoAntrian'
          },

          on: {
            'show:antrian': {
              target: 'PAGE_SUCCESS_SINGLE_CHECK_IN',
              actions: 'setCtxTicketCheckIn'
            }
          }
        },

        SELECTION_DATA: {
          entry: 'editCtxCheckInData',
          always: 'PAGE_MULTIPLE_CHECKIN'
        },

        TIMEOUT_GET_INFO: {
          invoke: {
            src: 'timeoutGetInfo',
            onDone: 'PAGE_ERROR'
          }
        }
      }
    },

    ADMIN_PAGE: {
      initial: 'ADMIN',
      states: {
        ADMIN: {
          after: {
            5000: {
              target: '#Ticket',
              actions: []
            }
          }
        }
      }
    },

    IDLE_PAGE: {
      entry: [
        'setCtxIdlePage',
        'deleteCtxArrTicketNotThisCluster',
        'deleteCtxObjTicketDetail'
      ],

      on: {
        'scan:ticket:kiosk': [
          {
            target: 'TICKET_MACHINE',
            cond: 'isPasienTicket',
            actions: ['setCtxLoadingPage', 'setCtxStrGeneratedId']
          },
          {
            target: 'ADMIN_PAGE',
            cond: 'isAdminTicket',
            actions: 'setCtxAdminPage'
          },
          {
            target: '#Ticket',
            actions: 'showToastError'
          }
        ]
      },

      states: {
        INIT: {
          always: {
            target: 'GET_LABEL',
            cond: 'isLabel'
          }
        },

        GET_LABEL: {
          invoke: {
            src: 'getLabelBadge',
            onDone: {
              target: 'DONE',
              actions: 'setCtxAllLabels'
            }
          }
        },

        DONE: {}
      },

      initial: 'INIT'
    }
  },

  on: {
    'push:config': {
      target: '#Ticket',
      internal: true,
      actions: 'setCtxConfigure'
    }
  },

  initial: 'IDLE_PAGE'
})

// context
// config : {
//   "screen": "kioskCheckIn",
//   "cluster": {
//     "id": "",
//     "nama": "",
//     "info": "",
//     "rs": ""
//   },
//   "delay": {
//     "buttonLinearCancelDelay": 2,
//     "buttonLinearCancelProgress": 10,
//     "buttonLinearCancelAfter": 2,
//     "timeOutCancel": 30
//   }
// }
